import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { Card, CardHeader, CardBody, Row, Col, CardTitle } from 'reactstrap';
import { translate } from "react-translate";

import { actionGetAnalysisList } from 'store/actions/analysisActions';
import TableAnalysis from './TableAnalysis';
import Paginator from '../Common/Paginator';
import Search from '../Common/Search'
import Switch from '../Common/Switch';
import Loading from "plugins/TS-lib-utils-public/components/Loading/LoadingGlobal";

const ListAnalysis = (props) => {
    const dispatch = useDispatch();
    const { t } = props;
    const { analysis } = useSelector(state => state.analysisReducer.analysis);
    const { pagination } = useSelector(state => state.analysisReducer.analysis);
    const [loading, setloading] = useState(false);
    const [loadingLocal, setloadingLocal] = useState(false);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [filter, setFilter] = useState(null);
    var   interval = false;
    var   activeFilter = '';

    useEffect(() => {
        dispatch(actionGetAnalysisList(page, limit));
    }, []);

    useEffect(() => {
        if (analysis && pagination) {
            setloading(false);
            setloadingLocal(false);
            setPage(pagination._page);
            setLimit(pagination._limit);
            setTotalPage(pagination._total_pages);
        }
    }, [dispatch, analysis]);

    //Callback del componente Check
    function intervalOnOff(isChecked, filter){
       if(ListAnalysis.interval){
            stopAutoRefresh();
       }

       if(isChecked === true){
            ListAnalysis.activeFilter = filter;
            startAutoRefresh(filter);
       }else{
            stopAutoRefresh();
       }
    }

    //Inicio el intervalo
    function startAutoRefresh(filter){
        ListAnalysis.interval = setInterval(() => {
            changeDataSearch(0, ListAnalysis.activeFilter);
        }, 2000);
    }

    //Detengo el intervalor.
    function stopAutoRefresh(){
        clearInterval(ListAnalysis.interval);
    }

    //method called by paginator and search
    function changeDataSearch(page, filter) {
        //if the search type "" refresh all data
        setloadingLocal(false)
        if (filter == null) {
            setFilter(null);
            dispatch(actionGetAnalysisList(page, limit));
        } else {
            //we save search input text, therefore we will only paginate the search results
            setFilter(filter);
            dispatch(actionGetAnalysisList(page, limit, filter));
        }
    }

    return (
        <div className='content user-manual'>           
                <CardBody>
                    <div>
                        <Loading loading={loading} />
                        <Switch label={t("title-real-time")} callback={intervalOnOff} filter={filter}/>
                        <Search placeholder={"search-text-logList"} callback={changeDataSearch} />
                        <TableAnalysis data={analysis} loading={loadingLocal} />
                        <Paginator totalPages={totalPage} currentPage={page} pageSize={limit} filter={filter} callback={changeDataSearch} />
                    </div>
                </CardBody>
        </div>
    );
};
export default translate("analysisDetail")(ListAnalysis);